import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';

interface Employee {
	name?: string;
}

interface NameProps {
	employee: Employee;
	idx: number;
	onChange: (idx: number, field: string, value: string) => void;
	nameRefs: React.MutableRefObject<Record<number, HTMLInputElement | null>>;
	disabled?: boolean;
}

const Name = ({
	employee,
	idx,
	onChange,
	nameRefs,
	disabled = false
}: NameProps): React.JSX.Element => {
	const { t } = useTranslation();

	return (
		<Input
			className="h-8 text-[16px] sm:text-xs"
			value={employee?.name || ''}
			placeholder={t('common.firstName')}
			onChange={(e) => onChange(idx, 'name', e.target.value)}
			ref={(el) => {
				nameRefs.current[idx] = el;
			}}
			maxLength={36}
			disabled={disabled}
			data-testid={`employee-${idx}-name-input`}
		/>
	);
};

export default Name;
